import * as angular from 'angular';
import { map } from 'lodash';

import ViewService from '../../../services/view-service';

class TableSettingsController {
  token: string;
  view: any;
  dataset: any;
  selectedColumns: Array<{ name: string; selected: boolean }>;

  static $inject = ['$scope', 'ViewService'];

  constructor(
    private $scope: angular.IScope,
    private vs: ViewService
  ) {}

  $onChanges(changed) {
    if (changed.view || changed.dataset) {
      this.setSelectedColumns();
    }
  }

  setSelectedColumns() {
    this.selectedColumns = map(this.dataset.columns, (col: any) => ({
      name: col.name,
      selected: this.view.excludeColumns ? this.view.excludeColumns.indexOf(col.name) < 0 : true,
    }));
  }

  checkCol = (name, $event) => {
    const excludeColumns = this.view.excludeColumns || [];
    const index = excludeColumns.indexOf(name);

    this.vs.updateTableExcludedColumn(this.token, index >= 0, name);
  };
}

export const TableSettingsDirective: angular.IComponentOptions = {
  controller: TableSettingsController,
  controllerAs: 'ctrl',
  template: `<h3 class="setting-title no-border-top">Columns</h3>
    <div ng-repeat="column in ctrl.selectedColumns" class="form-field check-field" style="margin:10px;">
      <span class="checkbox-icon">
        <input type="checkbox" id="{{column.name}}visible" value="{{column.name}}" ng-model="column.selected" ng-change="ctrl.checkCol(column.name,$event)" />
        <label class="inline-icon icon-editor-checkbox-light-unchecked" for="{{column.name}}visible">
        {{column.name}}
        </label>
      </span>
    </div>`,

  bindings: {
    view: '<',
    dataset: '<',
    token: '<',
  },
};
